var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecificPolicyArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.66602 15.5833H18.3327M18.3327 15.5833L14.666 11.9167M18.3327 15.5833L14.666 19.25M18.3327 6.41667H3.66602M3.66602 6.41667L7.33268 2.75M3.66602 6.41667L7.33268 10.0833",
    stroke: "#344054",
    strokeWidth: 1.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecificPolicyArrows);
export default __webpack_public_path__ + "static/media/specific-policy-arrows.9bb59a0a0ed9d8758d7e9eab614bdead.svg";
export { ForwardRef as ReactComponent };